import { cn, formatDate } from "../../../../utils/helpers";
import { IAddendumDetails } from "../../../../modules/notes/types/notes.types";
import NoteContentItem from "../NoteContentItem/NoteContentItem";
import { useGetDiagnosisCodesDisplay } from "../../../../hooks/helpers";
import { SUPERVISOR_DIAGNOSTIC_REVIEW_NOTE_DETAILS } from "../../../../utils/constants";
import styles from "../../../../modules/notes/components/NoteContent/NoteContent.module.scss";
import CheckIcon from "../../../../icons/Check";

interface ViewSupervisorDiagnosticReviewProps {
    noteContent: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key: string]: any;
    };
    fieldAddendums: {
        [key: string]: IAddendumDetails[];
    } | null;
}

export default function ViewSupervisorDiagnosticReview({
    noteContent,
    fieldAddendums,
}: ViewSupervisorDiagnosticReviewProps) {
    const diagonosisCodes = useGetDiagnosisCodesDisplay(
        noteContent.diagnosis_codes
    );

    const revisedDiagnosisCodes = useGetDiagnosisCodesDisplay(
        noteContent.revised_diagnosis_codes
    );

    const approvalStatement =
        "I have reviewed the clinical information and approve the diagnostic change " +
        "noted above.";

    return (
        <>
            <NoteContentItem
                headerText={
                    SUPERVISOR_DIAGNOSTIC_REVIEW_NOTE_DETAILS.date_of_review
                }
                fieldId="date_of_review"
                addendums={fieldAddendums?.date_of_review}
                content={
                    noteContent.date_of_review
                        ? formatDate(noteContent.date_of_review, true)
                        : "--"
                }
            />
            <NoteContentItem
                headerText={
                    SUPERVISOR_DIAGNOSTIC_REVIEW_NOTE_DETAILS.diagnosis_codes
                }
                fieldId="diagnosis_codes"
                addendums={fieldAddendums?.diagnosis_codes}
                content={
                    diagonosisCodes && Array.isArray(diagonosisCodes) ? (
                        <div className={styles.checkboxes}>
                            {diagonosisCodes.map((code) => (
                                <div className={styles.checkbox} key={code}>
                                    <span
                                        className={cn(styles.checkbox_wrap, {
                                            [styles.checked]: true,
                                        })}
                                    >
                                        <CheckIcon />
                                    </span>
                                    {code}
                                </div>
                            ))}
                        </div>
                    ) : (
                        "--"
                    )
                }
            />
            <NoteContentItem
                headerText={
                    SUPERVISOR_DIAGNOSTIC_REVIEW_NOTE_DETAILS.revised_diagnosis_codes
                }
                fieldId="revised_diagnosis_codes"
                addendums={fieldAddendums?.revised_diagnosis_codes}
                content={
                    revisedDiagnosisCodes &&
                    Array.isArray(revisedDiagnosisCodes) ? (
                        <div className={styles.checkboxes}>
                            {revisedDiagnosisCodes.map((code) => (
                                <div className={styles.checkbox} key={code}>
                                    <span
                                        className={cn(styles.checkbox_wrap, {
                                            [styles.checked]: true,
                                        })}
                                    >
                                        <CheckIcon />
                                    </span>
                                    {code}
                                </div>
                            ))}
                        </div>
                    ) : (
                        "--"
                    )
                }
            />
            {noteContent.new_clinical_information_supporting_diagnostic_change && (
                <NoteContentItem
                    headerText={
                        SUPERVISOR_DIAGNOSTIC_REVIEW_NOTE_DETAILS.new_clinical_information_supporting_diagnostic_change
                    }
                    fieldId="new_clinical_information_supporting_diagnostic_change"
                    addendums={
                        fieldAddendums?.new_clinical_information_supporting_diagnostic_change
                    }
                    content={
                        noteContent.new_clinical_information_supporting_diagnostic_change ||
                        "--"
                    }
                />
            )}
            <NoteContentItem
                headerText={
                    SUPERVISOR_DIAGNOSTIC_REVIEW_NOTE_DETAILS.diagnostic_rationale
                }
                fieldId="diagnostic_rationale"
                addendums={fieldAddendums?.diagnostic_rationale}
                content={noteContent.diagnostic_rationale || "--"}
            />
            <NoteContentItem
                headerText={
                    SUPERVISOR_DIAGNOSTIC_REVIEW_NOTE_DETAILS.reviewed_and_approved_by_lp
                }
                fieldId="reviewed_and_approved_by_lp"
                addendums={fieldAddendums?.reviewed_and_approved_by_lp}
                content={
                    noteContent.reviewed_and_approved_by_lp?.includes(
                        approvalStatement
                    )
                        ? approvalStatement
                        : "--"
                }
            />
        </>
    );
}
